import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { labelToDashes, mapBooleanToOpenClose } from "../utils";
import { IMenuItem } from "./IMenu";
import { MenuItem, MenuType } from "./MenuItem";
import { useMenu } from "./useMenu";

export type BlockItemProps = {
  label: string;
  children: IMenuItem[];
  onClickOnAnyLink: () => void;
  onChildOpen: (isOpen: boolean) => void;
  className: string;
  categoryButtonChildren: React.ReactNode;
};

export function BlockItem({
  label,
  children,
  onClickOnAnyLink,
  onChildOpen,
  className,
  categoryButtonChildren
}: BlockItemProps) {
  const { isOpen: menuIsOpen } = useMenu();
  const [isOpen, setOpen] = useState(false);
  const onClick = useCallback(() => {
    onClickOnAnyLink();
    setOpen(open => !open);
  }, [onClickOnAnyLink]);

  useEffect(() => {
    if (!menuIsOpen) {
      // close me when the entire menu is closed
      setOpen(false);
    }
  }, [menuIsOpen]);

  useEffect(() => {
    onChildOpen(!isOpen);
  }, [isOpen, onChildOpen]);

  return (
    <li className={className}>
      <CategoryButton
        isOpen={isOpen}
        onClick={onClick}
        label={label}
        children={categoryButtonChildren}
      />
      <MenuItem
        shouldSkipAnimation={!isOpen}
        className="elm-visible elm-p-4 elm-fixed elm-min-h-screen elm-overflow-y-auto md:elm-max-w-md elm-z-10 elm-pt-14 elm-top-0 elm-bottom-0 elm-left-0"
        menuType={MenuType.BACK_TITLE_ITEMS}
        label={label}
        children={children}
        parentIsOpen={isOpen}
        onClose={onClick}
        onClickOnAnyLink={onClickOnAnyLink}
      />
    </li>
  );
}

export const CategoryButton = ({ isOpen, label, onClick, children }) => {
  return (
    <button
      tabIndex={0}
      data-track-label={`btn:${mapBooleanToOpenClose(!isOpen)}:${labelToDashes(label)}`}
      className="focus:elm-outline-none elm-pointer-events-auto elm-cursor-pointer elm-font-sans elm-text-lg elm-border-0 elm-bg-transparent elm-px-0 elm-w-full elm-py-4 elm-flex elm-text-dd-gray-900 elm-transition elm-font-semibold elm-h-full elm-justify-center elm-items-center elm-relative"
      onClick={onClick}
      title={label}
      aria-label={label}
    >
      {children}
    </button>
  );
};
